var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.746,
    height: 23.551,
    viewBox: "0 0 23.746 23.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 23.747,
    height: 23.551,
    fill: "#6a707e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14152",
    "data-name": "Path 14152",
    d: "M13.978,38c-.569-.289-.68-.505-.567-1.1a2.347,2.347,0,0,1,2.34-1.834,17.729,17.729,0,0,1,2.115.048,2.235,2.235,0,0,1,1.979,2.15c-.007.381-.262.59-.607.741Z",
    transform: "translate(-4.732 -14.451)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14153",
    "data-name": "Path 14153",
    d: "M.6,38c-.572-.323-.686-.57-.541-1.185A2.376,2.376,0,0,1,2.4,35.061a17.292,17.292,0,0,1,2.089.048,2.219,2.219,0,0,1,1.988,2.162c-.008.385-.266.588-.618.729Z",
    transform: "translate(0 -14.45)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14154",
    "data-name": "Path 14154",
    d: "M27.353,38c-.557-.256-.694-.5-.6-1.073A2.355,2.355,0,0,1,29.1,35.063a17.179,17.179,0,0,1,2.139.051A2.234,2.234,0,0,1,33.2,37.25a.841.841,0,0,1-.592.751Z",
    transform: "translate(-9.458 -14.451)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14155",
    "data-name": "Path 14155",
    d: "M20.068,17c-.087.732-.172,1.454-.258,2.176-.152,1.287-.3,2.574-.459,3.86-.061.495-.459.766-1.143.812-.074,0-.148,0-.216,0-.7-2.01-1.955-2.965-3.842-2.937a3.722,3.722,0,0,0-3.636,2.915,1.085,1.085,0,0,1-1.385-.92q-.351-2.9-.693-5.8c0-.029-.01-.059-.021-.115-.2,0-.4,0-.6,0a.991.991,0,1,1,.019-1.965q6.422,0,12.844,0a.988.988,0,1,1,.037,1.964c-.134.005-.27,0-.4,0-.074,0-.148.006-.242.01",
    transform: "translate(-2.371 -6.194)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14156",
    "data-name": "Path 14156",
    d: "M16,11.292q-1.668,0-3.336,0c-.66,0-.972-.3-.941-.9a2.29,2.29,0,0,1,2.245-2.028q2.06-.039,4.119,0a2.268,2.268,0,0,1,2.248,2.214c-.016.429-.368.715-.9.716-1.146,0-2.291,0-3.437,0",
    transform: "translate(-4.146 -3.439)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14157",
    "data-name": "Path 14157",
    d: "M17.2,3.919a2.07,2.07,0,0,1-2.16-1.952A2.077,2.077,0,0,1,17.21,0a2.074,2.074,0,0,1,2.147,1.967A2.069,2.069,0,0,1,17.2,3.919",
    transform: "translate(-5.322 0)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14158",
    "data-name": "Path 14158",
    d: "M29.243,29.85a1.625,1.625,0,0,1,3.233,0,1.567,1.567,0,0,1-1.623,1.478,1.547,1.547,0,0,1-1.61-1.482",
    transform: "translate(-10.348 -11.704)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14159",
    "data-name": "Path 14159",
    d: "M17.483,28.391a1.477,1.477,0,1,1,.009,2.94,1.561,1.561,0,0,1-1.616-1.458,1.54,1.54,0,0,1,1.607-1.482",
    transform: "translate(-5.618 -11.704)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14160",
    "data-name": "Path 14160",
    d: "M4.141,28.39a1.531,1.531,0,0,1,1.6,1.48,1.548,1.548,0,0,1-1.608,1.461,1.567,1.567,0,0,1-1.625-1.476A1.55,1.55,0,0,1,4.141,28.39",
    transform: "translate(-0.889 -11.704)",
    fill: "#6a707e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventManagement);
export default __webpack_public_path__ + "static/media/EventManagement.d860722cf0a3893424ed9e73fb87628c.svg";
export { ForwardRef as ReactComponent };